import { useState } from "react";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import productApi from "../../api/productApi";
import ListComponent from "../Commons/ListComponent";
import Pagination from "../Commons/Pagination";
import ListFilter from "../Commons/ListFilter";
import { applyListFilter, applyListSort, applyListFilterAndSort } from "../../tools/GeneralHelper";
import useMount from "../../hooks/useMount";

import { getLabel, getLanguage } from "../../tools/Dictionary";

import { MdCheckCircle, MdRadioButtonUnchecked } from "react-icons/md";

const AdminProductDupFileModal = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const OnCloseModal = props.OnCloseModal;
  const OnSave = props.OnSave;
  const Id = props.Id;

  //PreFunction
  const onSelect = (_item, _selected) =>
  {
    //Check if _item._id exists in selected, if not add it, if exists remove it
    let tempSelected = [..._selected];

    if (tempSelected.find(s => s._id === _item._id))
    {
      tempSelected = tempSelected.filter(s => s._id !== _item._id);
    }
    else
    {
      tempSelected.push(_item);
    }


    setSelected(tempSelected);

  };

  //State
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState([]);
  const [currentProduct, setCurrentProduct] = useState([]);
  const [selected, setSelected] = useState([]);
  const [column, setColumn] = useState([
    {
      label: getLabel("T_Product", "code"),
      property: "code",
      style: { width: "15%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "20%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Product", "label"),
      property: "label",
      style: { width: "30%", minWidth: "100px" },
      isMobile: true,
      mobileStyle: { width: "20%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Product", "brand"),
      property: "brand.code",
      style: { width: "15%", minWidth: "50px" },
      isMobile: false,
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Product", "productFamily"),
      property: "productFamily.code",
      style: { width: "15%", minWidth: "50px" },
      isMobile: false,
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Product", "isActive"),
      property: "isActive",
      style: { width: "10%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "25%", minWidth: "50px" },
      format: "boolean",
      booleanValue: { true: getLabel("App", "Yes"), false: getLabel("App", "No") },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("App", "Action"),
      style: { width: "15%", minWidth: "50px" },
      mobileStyle: { width: "40%", minWidth: "50px" },
      isMobile: true,
      isMulti: true,
      button: [
        {
          title: getLabel("App", "Select"),
          isButton: true,
          isSelected: true,
          icon: <MdCheckCircle />,
          style: { width: "60px", height: "30px", fontSize: "20px", fontWeight: "bold", backgroundColor: "white", color: "#5ba644"},
          onClick: onSelect
        },
        {
          title: getLabel("App", "Select"),
          isButton: true,
          isSelected: false,
          icon: <MdRadioButtonUnchecked />,
          style: { width: "60px", height: "30px", fontSize: "20px", fontWeight: "bold", backgroundColor: "white", color: "black"},
          onClick: onSelect
        }
      ],
      noFilter: true
    }
  ]);
  const [sort, setSort] = useState({
    property: "",
    direction: 0 // Desc = 0, Asc = 1
  });
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10
  });
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  useMount(() =>
  {
    loadData();
  }, []);


  const loadData = async (_showLoading = true) =>
  {

    try
    {

      if (_showLoading)
      {
        setLoading(true);
      }

      let [productData] = await Promise.all([
        productApi.getProducts({ select: `_id,code,label,brand,productCategory,productType,productFamily,process,isActive,virtualAssistant`, translate: getLanguage().code, populate: "brand,productCategory,productType,productFamily,process" })
      ]);

      if (productData.Success)
      {

        let filteredProduct = productData.Data.filter(p => p._id != Id);

        let loadedProduct = applyListFilterAndSort(filteredProduct, column, sort);

        setProduct(loadedProduct);
        checkDataUpdateForPagination(loadedProduct, pagination);


      } else
        throw new Error(productData.Error.label);

      setLoading(false);

    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  
    const checkDataUpdateForPagination = (_data, _pagination, _resetPage = false) =>
    {
  
      let tempData = _data.filter(d => !d.bFiltered);
      let maxPage = Math.ceil(tempData.length / _pagination.perPage);
      let currentPage = _pagination.page;
  
      if (_resetPage)
        currentPage = 1;
      else if (_pagination.page > maxPage)
      {
        currentPage = maxPage > 0 ? maxPage : 1;
      }
  
      setCurrentProduct(sliceDataForPagination(_data, currentPage));
  
      setPagination(pagination => ({
        ...pagination,
        page: currentPage
      }));
    };
  
    const sliceDataForPagination = (_data, _page) =>
    {
  
      return _data.filter(d => !d.bFiltered).slice(pagination.perPage * (_page - 1), pagination.perPage * (_page - 1) + pagination.perPage);
  
    };
  
    const onClickSort = (_sort) =>
    {
  
      let tempData = applyListSort(product, _sort);
  
      setProduct(tempData);
      checkDataUpdateForPagination(tempData, pagination);
      setSort(_sort);
  
    };
  
    const onApplyFilter = (_column) =>
    {
  
      let tempData = applyListFilter(product, _column);
  
      setProduct(tempData);
      checkDataUpdateForPagination(tempData, pagination, true);
      setColumn(_column);
  
    };
  
  

  const onChangePage = (_page) =>
  {

    let tempPagination = {
      ...pagination,
      page: _page
    };

    checkDataUpdateForPagination(product, tempPagination);

  };

  const onClickItem = (_item) =>
  {
    onSelect(_item, selected);
  };

  const onClickConfirm = () => {

    if (loading || !OnSave) return;

    if (selected.length === 0) {
      setAlert(alert => ({  
        Title: getLabel("App", "Error"),
        Message: getLabel("AdminProduct", "Please select at least one product to duplicate the files."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      }));

      return;
    }

    //concaten select product codes
    let selectedCodes = selected.map(item => item.code).join(", "); 

    setConfirm(({
      Title: getLabel("AdminProduct", "Confirmation"),
      Message: getLabel("AdminProduct", "Are you sure you want to duplicate the files to the following products: {listSelected}?", { listSelected: selectedCodes }),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: () => onConfirm(selected),
      Display: true
    }));
  }

  const onConfirm = async(_selected) => {

    setConfirm(confirm => ({ ...confirm, Display: false }))

    try{

      let response = await OnSave(_selected);

      if (!response.Success){

        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

        throw error;

      }

    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      return;

    }


  }





  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "800px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("AdminProduct", "Duplicate files to others products")}
        </div>
        <div className="page_modal_body_cont">
          <div className="adminproduct_dup_file_text">
            {getLabel("AdminProduct", "Choose the destination products for file duplication. Please be aware that this action will overwrite the existing documents in all selected target products.")}
          </div>
          <div className="page_action_cont" style={{ width: "90%", maxWidth: "1200px" }}>
            <div className="page_action_section" style={{ width: "30%" }}>
            </div>
            <div className="page_action_section" style={{ width: "40%", justifyContent: "center" }}>
              <Pagination
                IsDesktop={IsDesktop}
                data={pagination}
                onChangePage={onChangePage}
                count={product.filter(p => !p.bFiltered).length}
              />
            </div>
            <div className="page_action_section" style={{ width: "30%", justifyContent: "right" }}>
              <ListFilter
                IsDesktop={IsDesktop}
                column={column}
                Data={product}
                OnApplyFilter={onApplyFilter}
              />
            </div>
          </div>
          <div style={{display: "flex", justifyContent: "center", marginTop: "10px" }}>
            <ListComponent
              IsDesktop={IsDesktop}
              Column={column}
              Data={currentProduct}
              Sort={sort}
              ListStyle={{ width: "90%", maxWidth: "1200px" }}
              Loading={loading}
              Debug={false}
              OnClickSort={onClickSort}
              OnClickItem={onClickItem}
              Selected={selected}
            />
          </div>

          <div className="adminproduct_dup_file_counter">
            {!loading && (
              <div>{getLabel("AdminProduct", "Selected products: ") + selected.length}</div>
            )}
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {(Access.canWrite && !ReadOnly) && 
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Confirm")}
              style={{ maxWidth: "200px" }}
              onClick={(loading && !OnSave) ? undefined : onClickConfirm}
              disabled={loading}
            />
          }
        </div>
      </div>
    </div>
  );

};

export default AdminProductDupFileModal